export const mapValidationToInputHelpers = (validation) => validation.error.issues.reduce((out, e) => {
  // eslint-disable-next-line no-param-reassign
  out[e.path[0]] = {
    type: 'error',
    value: e.message,
  };
  return out;
}, {});
